import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from '@/getters/index'
import * as actions from '@/actions/index'
import record from '@/store/records/'
let userMeProfile = localStorage.getItem('user') 
let authUser = localStorage.getItem('authUser')
let localStoredCart = JSON.parse(localStorage.getItem('cart')) || [];
Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  modules:{
    record
  },
  state: {
    added:localStoredCart,
    loading: {
      status: false,
      message:`Loading Please Wait...`
    },
    documents:[],
    dialog: {
      active: false,
      date: new Date(),
      data: {},
    },
    all:[],
    user: userMeProfile ? JSON.parse(userMeProfile) : new Object,
    authUser:authUser ? JSON.parse(authUser) : new Object,
    tickets:[],
    staff: [],
    posts:[],
    categories:[]
  },
  mutations: {
    ADD_CATEGORY (state, payload){
      const record = state.categories.find(item=> item.id === payload.id)
      if(!record || record === undefined) state.categories.push(payload)     
    },
    SET_APP_LOADER (state, payload) {
      state.loading = {...payload}
    },
    SET_CATEGORIES (state, payload) {
      state.categories = payload
    },
    SET_USER(state, payload){
      state.user = payload
    },
    CLEAR_USER(state){
      state.user = ' '
    },
    SET_STAFF_LISTS (state, payload) {
      state.staff = payload
    },
    TRIGGER_DIALOG (state, payload){
      state.dialog.data = payload.data
      state.dialog.date = new Date()
      state.dialog.active = true
    },
    CLEAR_DIALOG (state) {
      state.dialog.data = {}
      state.dialog.active = false
    },
    SET_TICKETS(state, payload){
      state.tickets = payload
    },
    SET_TICKET(state, payload){
      const record = state.tickets.find(item => item.id === payload.id)
        !record 
        ? this.state.tickets.push(payload)
        : false
    },
    ADD_POST (state, payload){
      const record = state.all.find(item=> item.id === payload.id)
      if(!record || record === undefined) state.all.push(payload)
    },
    ADD_BULK_POSTS (state,payload){
      state.posts[payload.slug] = payload.data
      payload.data.forEach(item => {
      const record = state.all.find(i=> i.id === item.id)
      if(!record || record === undefined) state.all.push(item)
    });
    },
    CLEAR_USER_DATA(state){
      state.user = new Object
      state.authUser = new Object
    },
    ADD_TO_CART (state, payload) {
      const record = state.added.find(product => product.id === payload.id)
      if (!record) {
        // eslint-disable-next-line
        M.toast({html: `<span> ${payload.name} added to basket</span><button style="margin-right:1px;" class="btn-flat toast-action">Pay</button>`})
        state.added.push({
          id: payload,
          quantity: 1,
        })
      localStorage.setItem('cart', JSON.stringify(state.added))
      } else {
        record.quantity++
      }
    }
  },
})
